import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetRoomsData } from '../types';

export const GET_ROOMS: TypedDocumentNode<IGetRoomsData> = gql`
  query getRooms {
    viewer {
      id
      site {
        id
        rooms {
          capacity
          created
          groupTypes
          id
          staff {
            id
            lastName
            firstName
            role
          }
          startPin
          status
          students {
            absent
            deniedEntry
            id
          }
          title
          updated
        }
      }
    }
  }
`;
